import { lazy } from "react";
import { connect } from "react-redux";
import {
  loading,
  data,
  pagination,
} from "../../../store/administration/selectors/areas";

const Areas = lazy(() => import("./Areas"));

const mapStateToProps = (state) => ({
  isLoading: loading(state),
  areas: data(state),
  pagination: pagination(state),
});

export default connect(mapStateToProps)(Areas);
